import gql from 'graphql-tag'

import { GUEST_FIELDS_FRAG } from './eventQueries'

export const CREATE_GUEST = gql`
  mutation createGuest($eventId: ID!, $input: GuestInput!, $tierIds: [ID!]) {
    createGuest(eventId: $eventId, input: $input, tierIds: $tierIds) {
      result {
        ...GuestFields
      }
      errors {
        key
        message
      }
    }
  }
  ${GUEST_FIELDS_FRAG}
`

export const UPDATE_GUEST = gql`
  mutation updateGuest($id: ID!, $input: GuestInput!, $tierIds: [ID!]) {
    updateGuest(id: $id, input: $input, tierIds: $tierIds) {
      result {
        ...GuestFields
      }
      errors {
        key
        message
      }
    }
  }
  ${GUEST_FIELDS_FRAG}
`

export const DELETE_GUEST = gql`
  mutation deleteGuest($id: ID!) {
    deleteGuest(id: $id) {
      result {
        id
        invitedBy {
          id
        }
        event {
          id
        }
      }
      errors {
        key
        message
      }
    }
  }
`

export const RESEND_BOOKING_CONFIRMATION_EMAIL = gql`
  mutation resendBookingConfirmationEmail($bookingId: ID!) {
    resendBookingConfirmationEmail(bookingId: $bookingId) {
      result {
        success
        message
      }
      errors {
        key
        message
      }
    }
  }
`

export const SEND_GUEST_LOGIN_LINK_TO_SUPPORT = gql`
  mutation sendGuestLoginLinkToSupport($guestId: ID!) {
    sendGuestLoginLinkToSupport(guestId: $guestId) {
      result {
        message
      }
      errors {
        key
        message
      }
    }
  }
`

export const SEND_BATCH_INVITATIONS = gql`
  mutation sendBatchInvitations($guestIds: [ID!]!) {
    sendBatchInvitations(guestIds: $guestIds) {
      result {
        id
        status
      }
      errors {
        key
        message
      }
    }
  }
`

export const SEND_BATCH_REMINDERS = gql`
  mutation sendBatchReminders($guestIds: [ID!]!, $template: String!) {
    sendBatchReminders(guestIds: $guestIds, template: $template) {
      result {
        id
        status
      }
      errors {
        key
        message
      }
    }
  }
`

export const SEND_SELF_INVITATION = gql`
  mutation sendSelfInvitation($eventId: ID!) {
    sendSelfInvitation(eventId: $eventId) {
      result {
        id
        status
      }
      errors {
        key
        message
      }
    }
  }
`

export const SEND_SELF_REMINDER = gql`
  mutation sendSelfReminder($eventId: ID!, $template: String!) {
    sendSelfReminder(eventId: $eventId, template: $template) {
      result {
        id
        status
      }
      errors {
        key
        message
      }
    }
  }
`
